require('es6-promise').polyfill();
require('isomorphic-fetch');
const BASE_HOST = "https://coingrasp.com/";
const REMOTE_HOST = "https://coingrasp.com/api/";
//const REMOTE_HOST = "//localhost:3001/";

class API {
    static isValidSymbol(symbol) {
        if (!symbol || symbol.length > 15) {
            return false;
        }
        return true;
    }

    static async updateCoins(appState) {
        let response = await fetch(BASE_HOST + 'coins.json');
        let coins = await response.json();
        appState.updated = coins[0].updated;
        return coins;
    }

    static async getCoin(appState) {
        let symbol = appState.selectedSymbol;
        if (!API.isValidSymbol(symbol)) {
            return;
        }

        let response = await fetch(REMOTE_HOST + 'coins/' + symbol);
        let coin = await response.json();
        appState.selectedCoin = coin;
        appState.updated = coin.updated;
        return coin;
    }

    static async searchCoin(appState, query) {
        if (query && query.length >= 3) {
            let response = await fetch(REMOTE_HOST + 'search/' + query);
            let search = await response.json();
            if (search) {
                appState.searchResults = search;
            } else {
                appState.searchResults = {};
            }
        } else {
            appState.searchResults = {};
        }

    }

    static async getChartData(appState) {
        let symbol = appState.selectedSymbol;
        if (!API.isValidSymbol(symbol)) {
            return;
        }

        let response = await fetch(REMOTE_HOST + 'chart/' + symbol);
        let chartData = await response.json();
        appState.selectedCoinChart = chartData;
        return chartData;
    }

    static async getChartDataWithTime(appState, time) {
        let symbol = appState.selectedSymbol;
        if (!API.isValidSymbol(symbol)) {
            return;
        }

        let response = await fetch(REMOTE_HOST + 'chart/' + symbol + '/' + time);
        let chartData = await response.json();
        appState.selectedCoinChart = chartData;
        return chartData;
    }

    static async updateCurrencies(appState) {
        let response = await fetch(REMOTE_HOST + 'currencies');
        let currencies = await response.json();
        appState.currencies = currencies;

        try {
            let selectedCurrency = appState.currency;
            for (let i=0; i<currencies.length; i++) {
                if (currencies[i].symbol === selectedCurrency.symbol) {
                    appState.currency = currencies[i];
                    window.localStorage.currency = JSON.stringify(appState.currency);
                }
            }
        } catch (err) {
            // Do nothing?
        }

        return currencies;
    }
}

export default API;



// WEBPACK FOOTER //
// ./src/API.js